import { Typography } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import SystemDialog from "../../../../../components/UIToolkit/Popups/Dialog";

interface EmployeeStatusChangeConfirmDialogProps {
	open: boolean;
	rawString: string;
	/** Display label of the effective status the row is changing to. */
	newStatusLabel: string;
	onConfirm: () => void;
	onClose: () => void;
}

/**
 * Confirmation shown before an admin's employee-status mapping change is written to the backend.
 * A status change is consequential — mapping a raw string to an inactive status stops syncing every
 * employee that carries it — so the write is deferred until the admin confirms here.
 */
export const EmployeeStatusChangeConfirmDialog: FC<EmployeeStatusChangeConfirmDialogProps> = ({ open, rawString, newStatusLabel, onConfirm, onClose }) => {
	const { t } = useTranslation();

	return (
		<SystemDialog
			open={open}
			onClose={onClose}
			title={t("hris.mapping.statusConfirm.title", { rawString, newStatus: newStatusLabel })}
			dataTestId="hris-mapping-employee-status-confirm-dialog"
			confirm={t("hris.mapping.statusConfirm.confirm")}
			onConfirm={onConfirm}
			body={
				<Typography variant="body2" color="text.secondary" sx={{ mt: 1, minWidth: 380 }}>
					{t("hris.mapping.statusConfirm.description")}
				</Typography>
			}
		/>
	);
};
